import axios from 'axios';
import { UserClaimInfo } from 'components/common';
import { legacyApiBaseUrl, remixPaymentToken } from './config';

// note: if testing locally, may want the EB api to hit the dev api but
// the mixpass api to hit local api
// const mixpassApiBaseURL = 'http://localhost:7071/api';
const mixpassApiBaseURL = legacyApiBaseUrl;

export interface ApiUserClaimInfo {
  merkleRoot: string;
  isClaimed: boolean;
  addressInWhitelist: boolean;
  claim?: UserClaimInfo;
}

export const getMixpassSaleStatus = async (): Promise<any> => {
  // const res = await axios.get(`${mixpassApiBaseURL}/mintpass-status`);
  // return res.data;
  return {
    price: 0,
    remainingSupply: 1000,
    publicSaleEnabled: false,
    paymentToken: {
      decimals: '18',
      symbol: 'WETH',
      address: remixPaymentToken,
    },
  };
};

export const getMixpassWhitelistStatus = async (whitelist: string): Promise<any> => {
  const res = await axios.get(
    `${mixpassApiBaseURL}/mintpass-whitelist-status?whitelist=${whitelist}`
  );
  return res.data;
};

export const getMixpassClaimStatus = async (
  whitelist: string,
  address: string
): Promise<ApiUserClaimInfo> => {
  if (!whitelist || !address) {
    throw new Error('Missing whitelist or address');
  }
  const res = await axios.get(
    `${mixpassApiBaseURL}/mintpass-claim-status?whitelist=${whitelist}&address=${address}`
  );
  return res.data;
};
